import React, { useEffect, useState } from 'react';
import { versionStore } from './VersionStore.js';
import { useStore } from '../store/useStore.js';
import './VersionTimeline.css';

export default function VersionTimeline() {
  const canvasId = useStore(state => state.canvasId);
  const [versions, setVersions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function loadVersions() {
      try {
        setLoading(true);
        const list = await versionStore.listVersions(canvasId);
        setVersions(list);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    }
    if (canvasId) {
      loadVersions();
    }
  }, [canvasId]);

  if (loading) return <div className="version-timeline-loading">Loading…</div>;
  if (error) return <div className="version-timeline-error">Error: {error}</div>;

  return (
    <div className="version-timeline">
      <h2 className="version-timeline-heading">Version history</h2>
      {versions.length === 0 ? (
        <p className="version-timeline-empty">No saved versions.</p>
      ) : (
        <ul className="version-timeline-list">
          {versions.map(v => (
            <li key={v.id} className="version-timeline-item">
              <div className="version-timeline-content">
                <span className="version-timeline-id">{v.id}</span>
                <span className="version-timeline-timestamp">
                  {new Date(v.meta.timestamp).toLocaleString()}
                </span>
                <button
                  className="version-timeline-restore-btn"
                  onClick={() => {
                    // TODO: integrate with HistoryManager
                    // We need to call versionStore.restoreVersion(v.id) then pass snapshot to HistoryManager
                    // We'll report the needed orchestrator change.
                    alert('Restore not yet integrated with HistoryManager');
                  }}
                >
                  Restore
                </button>
                <button
                  className="version-timeline-delete-btn"
                  onClick={() => {
                    versionStore.deleteVersion(v.id);
                  }}
                >
                  Delete
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}